import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from '@mui/material/CircularProgress';
import SaveIcon from '@mui/icons-material/Save';
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

import AddInvestmentAssetForm from "./AddInvestmentAssetForm";
import AddInvestmentProjectForm from "./AddInvestmentProjectForm";
import { addData, clearQueryResult, queryInvestmentProject, queryInvestmentAsset } from "../../actions/valueActions";


const AddInvestmentData = ({ id, industry, type, cost_category, costTypes, handleClose }) => {
    const formikRef = useRef(null);
    const dispatch = useDispatch();

    const [tab, setTab] = useState(0);
    const [loading, setLoading] = useState(false);

    const queryResult = useSelector(state => state.value.queryResult)

    const handleTabChange = (event, newValue) => {
        dispatch(clearQueryResult())
        setTab(newValue);
    };

    const addInvestmentFormAction = () => {
        return (
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                <Button
                    startIcon={<AutoFixHighIcon />}
                    type="submit"
                    disabled={loading}
                    sx={{ textTransform: 'none' }}
                >
                    Request
                </Button>
                {loading && (
                    <CircularProgress
                        size={24}
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: '-12px',  // half of 24
                            marginLeft: '-12px', // half of 24
                            zIndex: 1,
                        }}
                    />
                )}
            </Box>
        )
    }

    const saveInvestmentFormAction = () => {
        return (
            <React.Fragment>
                <Button
                    startIcon={<SaveIcon />}
                    type="submit"
                    sx={{ textTransform: 'none' }}
                >
                    Save
                </Button>
                <Button
                    startIcon={<AutoFixHighIcon />}
                    onClick={() => dispatch(clearQueryResult())}
                    sx={{ textTransform: 'none' }}
                >
                    Rerun Request
                </Button>
            </React.Fragment>
        )
    }

    const onSubmitInvestmentProject = async (values, { setSubmitting }) => {
        values.industry = industry
        values.investment_category = cost_category

        setLoading(true)
        let success = false

        const result = await dispatch(queryInvestmentProject(id, values, { setSubmitting }))

        success = result?.success;
        setLoading(false)

        if (formikRef.current && !success) {
            formikRef.current.resetForm();
        }
    }

    const onSubmitInvestmentAsset = async (values, { setSubmitting }) => {
        values.industry = industry
        values.investment_category = cost_category

        setLoading(true)
        let success = false

        const result = await dispatch(queryInvestmentAsset(id, values, { setSubmitting }))

        success = result?.success;
        setLoading(false)

        if (formikRef.current && !success) {
            formikRef.current.resetForm();
        }
    }

    const onSubmitSaveInvestmentProject = (values) => {
        values.lower = values.lower.toString().replace(/,/g, "");
        values.higher = values.higher.toString().replace(/,/g, "");

        dispatch(addData(id, type, 'investment_project', values))

        handleClose()
    }

    const onSubmitSaveInvestmentAsset = (values) => {
        let costPerMultiple = values.cost_per_multiple

        Object.keys(costPerMultiple).forEach(subType => {
            costPerMultiple[subType].lower = costPerMultiple[subType].lower.toString().replace(/,/g, '');
            costPerMultiple[subType].higher = costPerMultiple[subType].higher.toString().replace(/,/g, '');
        });

        values.cost_per_multiple = costPerMultiple

        dispatch(addData(id, type, 'investment_asset', values))

        handleClose()
    }

    function renderAddInvestmentProject() {
        // dispatch(clearQueryResult())

        return (
            <AddInvestmentProjectForm
                costTypes={costTypes}
                queryResult={queryResult}
                formActions={addInvestmentFormAction}
                formResultActions={saveInvestmentFormAction}
                onSubmit={(values, { setSubmitting }) => onSubmitInvestmentProject(values, { setSubmitting })}
                onSubmitResult={onSubmitSaveInvestmentProject}
                ref={formikRef}
            />
        )
    }

    function renderAddInvestmentAsset() {
        // dispatch(clearQueryResult())

        return (
            <AddInvestmentAssetForm
                costTypes={costTypes}
                queryResult={queryResult}
                formActions={addInvestmentFormAction}
                formResultActions={saveInvestmentFormAction}
                onSubmit={(values, { setSubmitting }) => onSubmitInvestmentAsset(values, { setSubmitting })}
                onSubmitResult={onSubmitSaveInvestmentAsset}
                ref={formikRef}
            />
        )
    }

    return (
        <Box>
            <Tabs
                value={tab}
                onChange={handleTabChange}
                sx={{ mb: 2, textTransform: 'none' }}
            >
                <Tab label="Add Investment Project" />
                <Tab label="Add Investment Asset" />
            </Tabs>
            {tab === 0 &&
                renderAddInvestmentProject()
            }
            {tab === 1 &&
                renderAddInvestmentAsset()
            }
        </Box>
    )
}

export default AddInvestmentData